<template>
  <div class="footer__link">
    <p v-if="caption" class="footer__link-title" v-text="$t(caption)" />
    <a
      v-for="(item, index) in links"
      :key="`${caption}-${index}`"
      :href="item.link"
      :target="target"
      :rel="relFor(item.link)"
      v-text="item.name"
    />
  </div>
</template>

<script setup lang="ts">
import { isOffsite } from '../links'

const props = defineProps({
  links: {
    type: Array as () => { name: string; link: string }[],
    default: () => [],
  },
  caption: {
    type: String,
    default: null,
  },
  target: {
    type: String,
    default: '_blank',
  },
  rel: {
    type: String,
    default: null,
  },
})

/**
 * `noopener` YALNIZ site dışına. Eskiden koşulsuz basılıyordu; SEO ekibi kendi
 * sayfalarımıza (blog, sözlük, fiyat) giden linklerde görüyordu.
 */
function relFor(link: string): string | undefined {
  const parts = [props.rel, isOffsite(link) ? 'noopener' : null].filter(Boolean)
  return parts.length ? parts.join(' ') : undefined
}
</script>
